import Avatar from '../Avatar';

/**
 * ChatTypingIndicator — extraído de ChatPanel.jsx en P3.1 sesión 3/4 (feb-2026).
 *
 * Loader de 3 puntos pulsando que indica que DamyxIA está procesando.
 * JSX y clases Tailwind IDÉNTICOS al original.
 *
 * Reglas del cuadro negro:
 * - NO maneja streaming real, solo renderiza UI.
 * - `isStreaming` aquí es el flag `isLoading` del ChatPanel original
 *   (este chat no usa SSE, usa fetch tradicional).
 */
const ChatTypingIndicator = ({ isStreaming }) => {
  if (!isStreaming) return null;

  return (
    <div className="flex gap-3 items-start">
      <Avatar size="sm" />
      <div className="flex items-center gap-2 px-4 py-3">
        <div className="w-2 h-2 bg-indigo-500 rounded-full animate-pulse" />
        <div
          className="w-2 h-2 bg-indigo-500 rounded-full animate-pulse"
          style={{ animationDelay: '0.2s' }}
        />
        <div
          className="w-2 h-2 bg-indigo-500 rounded-full animate-pulse"
          style={{ animationDelay: '0.4s' }}
        />
      </div>
    </div>
  );
};

export default ChatTypingIndicator;
